import * as ss from 'superstruct';
import { ConversionOutputStreamResource } from './output-stream.resource';
import { Id } from '../../types';
import { ConversionResource } from '../conversion.resource';
import { ConsumptionStatus, ScalarRecord } from './types';

export const ConversionOutputStreamConsumptionEventResource = ss.object({
  id: Id,
  outputStream: ConversionOutputStreamResource,
  conversion: ConversionResource,
  consumedAt: ss.date(),
  status: ConsumptionStatus,
  error: ss.optional(ss.nullable(ss.string())),
  pendingMetadata: ss.optional(ss.nullable(ScalarRecord)),
});

export type ConversionOutputStreamConsumptionEventResource = ss.Infer<
  typeof ConversionOutputStreamConsumptionEventResource
>;
